<template>
  <div :class="{'google-login--block': block}">
    <span ref="buttonRef" class="g-btn" />
  </div>
</template>

<script>
import { initGoogleApi } from '../../library/utils'

export default {
  props: {
    callback: { type: Function, required: true },
    isSignUp: { type: Boolean, default: false },
    outline: { type: Boolean, default: false },
    block: { type: Boolean, default: false }
  },
  data: () => ({
    resizeObserver: null,
    lastWidth: 0
  }),
  computed: {
    configuration () {
      return {
        client_id: this.$googleClientId,
        callback: this.callback,
        itp_support: true
      }
    }
  },
  mounted () {
    // initialize Google API and render Sign in With Google button
    initGoogleApi().then(() => {
      // initialize() は通常 アプリケーションで1回だけ呼ぶことが推奨されているため、ここで initialize()とする。
      window.google.accounts.id.initialize(this.configuration)
      // レイアウト確定後に幅を測って描画（初回の誤計測で iframe が親より広くなるのを防ぐ）
      this.$nextTick(() => {
        this.renderButton()
        if (this.block && typeof ResizeObserver !== 'undefined') {
          // 画面幅に合わせてボタンの幅を小さくする
          this.lastWidth = this.getButtonWidth()
          this.resizeObserver = new ResizeObserver(() => {
            const width = this.getButtonWidth()
            if (width !== this.lastWidth) {
              this.lastWidth = width
              this.renderButton()
            }
          })
          this.resizeObserver.observe(this.$el)
        }
      })
    }).catch((error) => {
      console.error('failed to init google api', error)
      this.$store.dispatch('alert', {
        title: this.$t('SocialAccounts.initGoogleFailure'),
        body: error.data
      })
    })
  },
  beforeUnmount () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  },
  methods: {
    getButtonWidth () {
      if (!this.block) return undefined
      // clientWidth で計測し、親の overflow で右端が欠けないよう 2px 余裕を見る
      // GSI の width 上限は 400px
      const width = this.$el?.clientWidth
      if (!width) return 360
      return Math.min(400, Math.max(200, Math.floor(width) - 2))
    },
    renderButton () {
      /**
       * Render the Sign in With Google button
       * reference: https://developers.google.com/identity/gsi/web/guides/display-button#javascript
       */
      const button = this.$refs.buttonRef
      if (!button || !window.google?.accounts?.id) return
      // renderButton() が複数回呼ばれるタイミング
      //  1. 初回 — mounted 時
      //  2. 再描画 — block モードで画面幅が変わったとき（ResizeObserver 経由）
      //  ↑のタイミングで複数回呼ばれるため、button.innerHTML = '' で一度クリアする
      button.innerHTML = ''
      window.google.accounts.id.renderButton(button, {
        theme: this.outline ? 'outline' : 'filled_blue',
        text: this.isSignUp ? 'signup_with' : 'signin_with',
        size: 'large',
        width: this.getButtonWidth(),
        locale: this.$i18n.locale
      })
    }
  }
}
</script>

<style scoped>
.google-login--block {
  width: 100%;
  max-width: 100%;
  line-height: 0;
}

.google-login--block .g-btn {
  display: flex;
  justify-content: center;
  width: 100%;
  line-height: 0;
}

/*
  iframe を CSS で縮めると、中のボタン描画サイズはそのままなので右端が欠ける。
  幅は renderButton の width で合わせ、表示枠は縮めない。
*/
.google-login--block .g-btn :deep(iframe) {
  flex-shrink: 0;
  border: none;
}
</style>
